import { useVisitStore } from "@/store/visit";
import { loadLanguage, setVisitUid, VISIT_UID_KEY } from "@/utils/storage";
import { getCookie } from "@/utils/cookies";
import { MiddlewareInterface } from "@/interfaces/Middleware.ts";
import { changeLanguage } from "@/i18n.ts";

export default async ({ pinia }: MiddlewareInterface) => {
  const visitCookie = getCookie(VISIT_UID_KEY);

  if (visitCookie) {
    setVisitUid(visitCookie);
  }

  const visitStore = useVisitStore(pinia);

  if (!visitStore.getVisit) {
    const lang = (loadLanguage() || document.documentElement.getAttribute("lang") || "en") as "en" | "de" | "fr";
    await Promise.all([changeLanguage(lang), visitStore.ensureVisitTracked(lang)]);
  }
};
